import React from 'react';

interface TextFormatterProps {
  value: React.ReactNode;
}

const TextFormatter: React.FC<TextFormatterProps> = ({ value }) => {
  return <div className="formatter formatter--text">{value}</div>;
};

export default TextFormatter;
